import React from "react";
import IsInStock from "./IsInStock";
import ErcModal from "../../modules/shared/components/ErcModal";
import PriceOfferChildGrandUpsellExplainer from "./PriceOfferChildGrandUpsellExplainer";
import { calculateDisplayedPrice } from "../../utils/calculateDisplayedPrice";

export default function PriceOfferChildGrandUpsellDiscounted(props) {
  // PROPS COMING FROM TimeRestrictedPriceOffer
  const { product, price, isPending /*hasItemInPendingOrder*/ } = props;

  return (
    <table style={{ width: "95%" }}>
      <thead>
        <tr
          style={{
            backgroundColor: "lightgrey",
            fontSize: "1rem",
          }}
        >
          {
            <th
              style={{
                border: "2px solid white",
                width: "50%",
              }}
            >
              <div className="row-center padq txtcenter">
                Ek Sipariş Fiyatı{" "}
                <ErcModal
                  modalTitle={() => (
                    <i className="far fa-question-circle green fs1 marq"></i>
                  )}
                  modalTitleFontSize={"1.25rem"}
                  modalTitleLineHeight={"2rem"}
                  modalTitleColor={"#0645ad"}
                  modalTitleUnderline={""}
                  contentTitle={`Ek Sipariş İndirimi Nedir?`}
                  contentTitleFontSize={"1.35rem"}
                  content={[
                    <PriceOfferChildGrandUpsellExplainer
                      isPending={isPending}
                    />,
                  ]}
                  modalParagBorderBottom={""}
                  modalParagFontSize={"1.25rem"}
                />
              </div>
            </th>
          }
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div className="row w95p fs125 txtcenter padq">
              <div className="w70p row">
                <strike className="red-col w10p bold-font">
                  {calculateDisplayedPrice(price.price)}
                </strike>{" "}
                <p className="w90p">
                  {calculateDisplayedPrice(price.priceGap)} TL
                </p>
              </div>
              <div className="w30p txtright">
                <IsInStock product={product} />
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr
          style={{
            backgroundColor: "lightgrey",
            fontSize: "1rem",
          }}
        >
          <th
            style={{
              border: "2px solid white",
              width: "50%",
            }}
          >
            <p className="padq txtcenter">
              Ana sipariş paketlenene kadar geçerli
            </p>
          </th>
        </tr>
      </tfoot>
    </table>
  );
}
